
import { WorldCity } from '../types';

// Expansión de Argentina - 70 ciudades adicionales
export const argentinaAdditionalCities: WorldCity[] = [
  { name: 'Córdoba', slug: 'cordoba', population: 1329604 },
  { name: 'Rosario', slug: 'rosario', population: 948312 },
  { name: 'Mendoza', slug: 'mendoza', population: 114893 },
  { name: 'Tucumán', slug: 'tucuman', population: 548866 },
  { name: 'La Plata', slug: 'la-plata', population: 649613 },
  { name: 'Mar del Plata', slug: 'mar-del-plata', population: 614350 },
  { name: 'Salta', slug: 'salta', population: 535303 },
  { name: 'Santa Fe', slug: 'santa-fe', population: 489505 },
  { name: 'San Juan', slug: 'san-juan', population: 447048 },
  { name: 'Resistencia', slug: 'resistencia', population: 290723 },
  { name: 'Santiago del Estero', slug: 'santiago-del-estero', population: 252192 },
  { name: 'Corrientes', slug: 'corrientes', population: 346334 },
  { name: 'Posadas', slug: 'posadas', population: 324756 },
  { name: 'Neuquén', slug: 'neuquen', population: 231780 },
  { name: 'Bahía Blanca', slug: 'bahia-blanca', population: 301572 },
  { name: 'Paraná', slug: 'parana', population: 247863 },
  { name: 'Formosa', slug: 'formosa', population: 222226 },
  { name: 'San Salvador de Jujuy', slug: 'san-salvador-de-jujuy', population: 305891 },
  { name: 'San Luis', slug: 'san-luis', population: 183982 },
  { name: 'Catamarca', slug: 'catamarca', population: 205900 },
  { name: 'La Rioja', slug: 'la-rioja', population: 180995 },
  { name: 'Río Cuarto', slug: 'rio-cuarto', population: 157010 },
  { name: 'Comodoro Rivadavia', slug: 'comodoro-rivadavia', population: 182631 },
  { name: 'Concordia', slug: 'concordia', population: 138099 },
  { name: 'San Nicolás de los Arroyos', slug: 'san-nicolas-de-los-arroyos', population: 133602 },
  { name: 'Tandil', slug: 'tandil', population: 123871 },
  { name: 'San Rafael', slug: 'san-rafael', population: 118620 },
  { name: 'Olavarría', slug: 'olavarria', population: 111320 },
  { name: 'Pergamino', slug: 'pergamino', population: 104590 },
  { name: 'Luján', slug: 'lujan', population: 106273 },
  { name: 'Villa María', slug: 'villa-maria', population: 80271 },
  { name: 'Río Gallegos', slug: 'rio-gallegos', population: 98014 },
  { name: 'Ushuaia', slug: 'ushuaia', population: 79074 },
  { name: 'San Fernando del Valle de Catamarca', slug: 'san-fernando-del-valle-de-catamarca', population: 205900 },
  { name: 'Villa Carlos Paz', slug: 'villa-carlos-paz', population: 75311 },
  { name: 'Gualeguaychú', slug: 'gualeguaychu', population: 83116 },
  { name: 'Azul', slug: 'azul', population: 62996 },
  { name: 'Rafaela', slug: 'rafaela', population: 99150 },
  { name: 'Venado Tuerto', slug: 'venado-tuerto', population: 76432 },
  { name: 'Villa Mercedes', slug: 'villa-mercedes', population: 111391 },
  { name: 'Reconquista', slug: 'reconquista', population: 99055 },
  { name: 'Trelew', slug: 'trelew', population: 99430 },
  { name: 'Puerto Madryn', slug: 'puerto-madryn', population: 93995 },
  { name: 'Cipolletti', slug: 'cipolletti', population: 77742 },
  { name: 'General Roca', slug: 'general-roca', population: 90607 },
  { name: 'Zárate', slug: 'zarate', population: 114269 },
  { name: 'San Carlos de Bariloche', slug: 'san-carlos-de-bariloche', population: 132876 },
  { name: 'Campana', slug: 'campana', population: 94461 },
  { name: 'Necochea', slug: 'necochea', population: 89096 },
  { name: 'Junín', slug: 'junin', population: 85420 },
  { name: 'Mercedes', slug: 'mercedes-buenos-aires', population: 63284 },
  { name: 'San Pedro', slug: 'san-pedro', population: 59001 },
  { name: 'Chivilcoy', slug: 'chivilcoy', population: 64185 },
  { name: 'Trenque Lauquen', slug: 'trenque-lauquen', population: 43021 },
  { name: 'General Pico', slug: 'general-pico', population: 58795 },
  { name: 'Santa Rosa', slug: 'santa-rosa', population: 124101 },
  { name: 'Viedma', slug: 'viedma', population: 80632 },
  { name: 'San Martín de los Andes', slug: 'san-martin-de-los-andes', population: 32009 },
  { name: 'Villa La Angostura', slug: 'villa-la-angostura', population: 18192 },
  { name: 'El Calafate', slug: 'el-calafate', population: 22014 },
  { name: 'Rawson', slug: 'rawson', population: 31787 },
  { name: 'Esquel', slug: 'esquel', population: 32339 },
  { name: 'Villa Gesell', slug: 'villa-gesell', population: 31730 },
  { name: 'Pinamar', slug: 'pinamar', population: 25728 },
  { name: 'Cariló', slug: 'carilo', population: 1021 },
  { name: 'Tigre', slug: 'tigre', population: 376381 },
  { name: 'San Isidro', slug: 'san-isidro', population: 292878 },
  { name: 'Vicente López', slug: 'vicente-lopez', population: 269420 },
  { name: 'Morón', slug: 'moron', population: 321109 },
  { name: 'San Martín', slug: 'san-martin', population: 414196 },
  { name: 'Tres de Febrero', slug: 'tres-de-febrero', population: 336467 },
  { name: 'Quilmes', slug: 'quilmes', population: 582943 }
];

export const argentinaExpanded = {
  code: 'AR',
  name: 'Argentina',
  slug: 'argentina',
  population: 45376763,
  topCities: [
    { name: 'Buenos Aires', slug: 'buenos-aires', population: 2890151 },
    ...argentinaAdditionalCities
  ]
};
